export const AGENT_RATING_DAYS_LIMIT = 15;
